import React from "react";
import SegmentedWordsView from "./SegmentedWordsView";
import SegmentedPhrasesView from "./SegmentedPhrasesView";

interface DictionaryViewProps {
  type: "Words" | "Phrases";
  onClose: () => void;
  // this function should be called when the user wants to udpate the status of a word or phrase.
  // tells the parent the lists are dirty and can be refetched on next click away
  onStatusUpdate: () => void;
  phraseQueryKeys: {
    knownPhrasesKey: string;
    learningPhrasesKey: string;
  };
  dictionaryStats: {
    knownWordCount: number;
    learningWordCount: number;
    knownPhraseCount: number;
    learningPhraseCount: number;
  };
}

const DictionaryView = React.forwardRef<
  { refreshQueries: () => void },
  DictionaryViewProps
>(
  (
    { type, onClose, onStatusUpdate, phraseQueryKeys, dictionaryStats },
    ref
  ) => {
    const wordListRef = React.useRef<{ refreshQueries: () => void }>(null);
    const phrasesViewRef = React.useRef<{ refreshQueries: () => void }>(null);

    React.useImperativeHandle(ref, () => ({
      refreshQueries: () => {
        if (type === "Words") {
          wordListRef.current?.refreshQueries();
        } else if (type === "Phrases") {
          phrasesViewRef.current?.refreshQueries();
        }
      },
    }));

    return (
      <div className="flex flex-col w-full gap-4">
        {type === "Words" ? (
          <SegmentedWordsView
            ref={wordListRef}
            onClose={onClose}
            onStatusUpdate={onStatusUpdate}
          />
        ) : (
          <SegmentedPhrasesView
            ref={phrasesViewRef}
            onClose={onClose}
            onPhraseStatusUpdate={onStatusUpdate}
            phraseQueryKeys={phraseQueryKeys}
            dictionaryStats={dictionaryStats}
          />
        )}
      </div>
    );
  }
);

export default DictionaryView;
